import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import {
    DocumentTypeSummary,
    DriverProfile,
    DocumentSummary,
} from 'src/app/demo/models/common-data-types';
import { DocumentsService } from 'src/app/demo/service/documents.service';
import { DataViewModule } from 'primeng/dataview';
import { LanguageService } from 'src/app/demo/service/language.service';
import { NgxTranslateModule } from 'src/app/translate.module';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ScreenSizeService } from 'src/app/demo/service/screen-size.service';
import { CustomToastrService } from 'src/app/demo/service/custom-toastr.service';

@Component({
    selector: 'app-show-documents',
    standalone: true,
    imports: [
        CommonModule,
        TableModule,
        CardModule,
        ButtonModule,
        DataViewModule,
        NgxTranslateModule,
        TooltipModule,
    ],
    templateUrl: './show-documents.component.html',
    styleUrl: './show-documents.component.scss',
})
export class ShowDocumentsComponent implements OnInit {
    @Input()
    documents: DocumentSummary[] = [];
    selectedLanguage: any = null;

    constructor(
        private languageService: LanguageService,
        private translate: TranslateService,
        private documentService: DocumentsService,
        private screenSizeService: ScreenSizeService,
        private wiseToastr: CustomToastrService
    ) {}

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    downloadClicked(id: string, item: DocumentSummary) {
        this.documentService.download(id).subscribe((res) => {
            let blob: Blob = res.body as Blob;
            let url = window.URL.createObjectURL(blob);

            let a = document.createElement('a');
            a.download = item.documentName
                .concat('_')
                .concat(item.originalFileName);
            a.href = url;
            a.click();
            this.showSuccess('Downloaded Successfully');
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    ngOnInit() {
        this.initializeLocale();
    }

    getDeviceType(): string {
        return this.screenSizeService.getDeviceType();
    }

    getDeviceHeight(): number {
        return this.screenSizeService.getScreenDimensions().height;
    }

    showSuccess(message: string){
        this.wiseToastr.showSuccess(message);
    }
}
